const storeReport = {
    path: 'storeReport',
    name: 'storeReport',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'report',
        icon: 'HSIconfont hs-icon-report',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeReportList',
            name: 'storeReportList',
            component: () => import('@/views/storeReportList'),
            meta: { code: 'report:store' }

        }
    ]
};

export default storeReport;
